<template>
  <div class="login-index-content wd-items-end">
    <div class="wd-flex wd-flex-wrap wd-items-end wd-pb-5">
      <v-btn
        class="login-index__btn login-btn--default wd-mb-5"
        color="black50"
        :loading="loginLoading"
        variant="outlined"
        width="100%"
        :height="40"
        @click="login"
      >
        {{ $t('funbook_login_button') }}
      </v-btn>
      <v-btn
        class="login-index__btn login-btn--default"
        color="black50"
        :loading="loginLoading"
        variant="outlined"
        width="100%"
        :height="40"
        @click="loginByAnonymous"
      >
        <template #loader>
          <Loading />
        </template>
        {{ $t('funbook_nonlogin_button') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/icons/loading.vue'

export default defineComponent({
  components: {
    Loading,
  },
  emits: ['success', 'changeAuthStep'],
  setup(_, ctx) {
    const loginLoading = ref(false)

    const { $store: store } = useNuxtApp()

    async function loginByAnonymous() {
      try {
        const res = await store.dispatch('authentication/login', { anonymous: true })
        loginLoading.value = false
        if (res.code !== 0) return
        // sendTrackingCode(res.data.uid)
        ctx.emit('success')
      } catch (error) {
        console.error(error)
      } finally {
        loginLoading.value = false
      }
    }

    function createAccount() {
      ctx.emit('changeAuthStep', 'sign-up')
    }

    function login() {
      ctx.emit('changeAuthStep', 'index')
    }

    return {
      loginLoading,
      loginByAnonymous,
      createAccount,
      login,
    }
  },
})
</script>
<style scoped lang="scss">
.login-index-content {
  .login-index {
    &__btn {
      font-size: 17px;
      &.login-btn--default {
        border-color: $gray50 !important;
      }
    }

    &__footer {
      margin-top: 152px;
      font-size: 13px;
    }
  }
}
</style>
